import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
import { formatBps } from '@capital/intl/utils';
export default Helper.extend({
  intl: service(),
  compute([bps]) {
    return formatBps(bps, this.intl);
  }
});